// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","container":"BuildsByBuildType__container--YZ","list":"BuildsByBuildType__list--MI","item":"BuildsByBuildType__item--di"};